import clsx from 'clsx';
import React, { ReactNode } from 'react';
import Heading from 'components/atoms/Heading/Heading';
import classes from './ActivityBanner.module.scss';

type HeadingLevel = React.ComponentProps<typeof Heading>['level'];

export type ActivityBannerProps = {
  title?: ReactNode;
  headingLevel?: HeadingLevel;
  infoButton?: ReactNode;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLDivElement>;
  role?: React.AriaRole;
  tabIndex?: number;
  className?: string;
  headerClassName?: string;
  headerTitleClassName?: string;
  cardClassName?: string;
  cardBackgroundColor?: string;
  cardTextColor?: string;
  children: ReactNode;
};

export default function ActivityBanner({
  title,
  headingLevel = 3,
  infoButton,
  onClick,
  onKeyDown,
  role,
  tabIndex,
  className,
  headerClassName,
  headerTitleClassName,
  cardClassName,
  cardBackgroundColor,
  cardTextColor,
  children,
}: ActivityBannerProps) {
  const shouldRenderHeader = title || infoButton;
  const isInteractive = Boolean(onClick || onKeyDown || role || tabIndex !== undefined);

  return (
    <div className={clsx(classes.root, className)}>
      {shouldRenderHeader && (
        <header className={clsx(classes.header, headerClassName)}>
          {title && (
            <Heading
              level={headingLevel}
              className={clsx(classes.headerTitle, headerTitleClassName)}
            >
              {title}
            </Heading>
          )}
          {infoButton}
        </header>
      )}
      <div
        className={clsx(classes.card, isInteractive && classes.rootInteractive, cardClassName)}
        onClick={onClick}
        onKeyDown={onKeyDown}
        role={role}
        tabIndex={tabIndex}
        style={
          cardBackgroundColor || cardTextColor
            ? {
                backgroundColor: cardBackgroundColor,
                color: cardTextColor,
              }
            : undefined
        }
      >
        {children}
      </div>
    </div>
  );
}
